export default __webpack_public_path__ + "static/media/money_market_light.8679a8fc.png";